import { DiscordIcon, WhatsAppIcon } from 'assets/icons/Social'
import React from 'react'

export const JoinDiscordButton = () => {
  return (
    <a href="https://devsnest.in/discord" target="_blank" rel="noreferrer">
      <div className="text-base sm:text-lg py-2 px-6 bg-indigo-700 hover:bg-indigo-800 rounded cursor-pointer mx-2.5">
        <div className="flex items-center">
          <DiscordIcon className="h-5 w-5" />
          <span className="ml-2">Join Discord</span>
        </div>
      </div>
    </a>
  )
}

export const JoinWhatsAppButton = () => (
  <a href="https://devsnest.in/whatsapp" target="_blank" rel="noreferrer">
    <div className="text-base sm:text-lg py-2 px-6 bg-green-800 hover:bg-green-900 rounded cursor-pointer mx-2.5">
      <div className="flex items-center">
        <WhatsAppIcon className="h-5 w-5" />
        <span className="ml-2">Join WhatsApp</span>
      </div>
    </div>
  </a>
)
